module.exports = "/_next/static/images/case2-cover-046d0c0f33260950d9eb988d6a852b1a.jpg";